import React, { useEffect, useState } from "react";
import CanvasJSReact from "@canvasjs/react-charts";
import trasportApi from "../../api/trasportApi";
import Select from "react-select";
import Form from "react-bootstrap/Form";
import { Col, Button } from "react-bootstrap";

const CanvasJSChart = CanvasJSReact.CanvasJSChart;

const LineChart = ({ filterDateData }) => {
  const [optionLead, setOptionLead] = useState([]);
  const [selectedLead, setSelectedLead] = useState(null);
  const [projectsData, setProjectsData] = useState([]);

  // Fetch initial data on component load or filterDateData change
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        // Fetch leads data
        const fetchLeads = await trasportApi.fetchAllVehicles();
        if (fetchLeads && Array.isArray(fetchLeads)) {
          const leadOptions = fetchLeads.map((item) => ({
            value: item.id,
            label: item.vehicle_number,
          }));
          setOptionLead(leadOptions);
        }

        // Fetch projects data based on filterDateData
        console.log("filterDateDatafilterDateData",filterDateData);
        if (filterDateData?.month && filterDateData?.financial_year_id) {
          const fetchProjects = await trasportApi.fetchInvoiceCurrentMonthDasboard(filterDateData);
          console.log("fetchProjectsfetchProjects",fetchProjects);
          setProjectsData(fetchProjects || []);
        }
      } catch (error) {
        console.error("Error fetching initial data:", error);
        setProjectsData([]);
      }
    };

    fetchInitialData();
  }, [filterDateData]);

  // Fetch projects when lead changes
  useEffect(() => {
    const fetchProjectsByLeadId = async () => {
      try {
        if (selectedLead) {
          const fetchProject = await trasportApi.fetchInvoiceCurrentMonthDasboardByVechicleId(selectedLead.value);
          setProjectsData(fetchProject || []);
        } else if (filterDateData?.month && filterDateData?.financial_year_id) {
          const fetchProjects = await trasportApi.fetchInvoiceCurrentMonthDasboard(filterDateData);
          setProjectsData(fetchProjects || []);
        }
      } catch (error) {
        console.error("Error fetching projects by lead ID:", error);
        setProjectsData([]);
      }
    };

    fetchProjectsByLeadId();
  }, [selectedLead, filterDateData]);
 
  console.log("Hello LineChart",projectsData)
  // Chart options
  const options = {
    animationEnabled: true,
    axisY: {
      title: "Client Total Amount",
      scaleBreaks: {
        autoCalculate: true,
        type: "wavy",
        lineColor: "black",
      },
    },
    data: projectsData.length > 0
      ? [
          {
            type: "column",
            indexLabel: "{y}",
            indexLabelFontColor: "black",
            toolTipContent: `<strong>{label}</strong><br/>
              Total Amount: {invoice_total_amount}<br/>
              Pending Amount: {project_pending_amount}<br/>
              Received Amount: {project_amount_received}`,
            dataPoints: projectsData.map((project) => ({
              label: project.client_name,
              y: parseFloat(project.invoice_amount) || 0,
              invoice_total_amount: project.invoice_amount || 0,
              pending_amount: project.pendingamount || 0,
              project_amount_received: project.paidamount || 0,
            })),
          },
        ]
      : [],
  };

  // Clear the selected lead and reset data
  const handleClear = () => {
    setSelectedLead(null);
    setProjectsData([]);
  };

  return (
    <div>
      <Col lg={4} className="mt-4">
        <Form.Group>
          <div className="d-flex">
            <Select
              required
              placeholder="Select Vechicle Name..."
              onChange={setSelectedLead}
              options={optionLead}
              value={selectedLead}
            />
            <Button variant="secondary" onClick={handleClear} className="ms-2">
              Clear
            </Button>
          </div>
        </Form.Group>
      </Col>
      <div className="mt-4">
        {projectsData.length > 0 ? (
          <CanvasJSChart options={options} />
        ) : (
          <div className="text-center text-danger mt-2">No Record Found</div>
        )}
      </div>
    </div>
  );
};

export default LineChart;